export const RESET = 'RESET'
export const SUCCESS = 'SUCCESS'
export const ERROR = 'ERROR'
export const WARNING = 'WARNING'
export const INFO = 'INFO'
export const LOADING = 'LOADING'

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const AUTH_ERROR = 'AUTH_ERROR'
export const SIGNOUT_SUCCESS = 'SIGNOUT_SUCCESS'
export const INVITE_MEMBER_SUCCESS = 'INVITE_MEMBER_SUCCESS'
export const INVITE_MEMBER_ERROR = 'INVITE_MEMBER_ERROR'
export const FLIGHT_CREATE_SUCCESS = 'FLIGHT_CREATE_SUCCESS'
export const RESET_NOTIFICATIONS = 'RESET_NOTIFICATIONS'
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION'
export const NOTIFICATIONS_ALLOWED = 'NOTIFICATIONS_ALLOWED'
export const SELECT_AIRCRAFT = 'SELECT_AIRCRAFT'

export const SELECT_YEAR = 'SELECT_YEAR'
export const SELECT_USER = 'SELECT_USER'
export const SELECT_ACCOUNT = 'SELECT_ACCOUNT'
export const SELECT_ACTIVITY = 'SELECT_ACTIVITY'

export const FETCH_MEMBERS_SUCCESS = 'FETCH_MEMBERS_SUCCESS'
export const TOGGLE_MENU_DRAWER = 'TOGGLE_MENU_DRAWER'
export const TOGGLE_ADMIN_MODE = 'TOGGLE_ADMIN_MODE'

export const TRANSFER_SUCCESS = 'TRANSFER_SUCCESS'
export const TRANSFER_ERROR = 'TRANSFER_ERROR'

export const CREATE_PROGRESS_BOOK_SUCCESS = 'CREATE_PROGRESS_BOOK_SUCCESS'
export const CREATE_PROGRESS_BOOK_ERROR = 'CREATE_PROGRESS_BOOK_ERROR'
export const SELECT_LESSON = 'SELECT_LESSON'
